import script from "./VInfoItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInfoItem.vue?vue&type=script&setup=true&lang=ts"

import "./VInfoItem.vue?vue&type=style&index=0&id=ca2f7244&lang=scss"

const __exports__ = script;

export default __exports__